// SVG icon mapping - Using newer Flaticon IDs that work

const catIconsMap = {
  // User provided icons
  "Cats": "https://cdn-icons-png.flaticon.com/512/10890/10890561.png",
  "Beetles": "https://cdn-icons-png.flaticon.com/512/8689/8689753.png",
  
  // Using beetle as placeholder for insects until user provides specific icons
  "Ants": "https://cdn-icons-png.flaticon.com/512/357/357573.png",
  "Bugs": "https://cdn-icons-png.flaticon.com/512/47/47253.png",
  "Butterflies": "https://cdn-icons-png.flaticon.com/512/42/42496.png",
  "Centipedes": "https://cdn-icons-png.flaticon.com/512/1328/1328901.png",
  "Millipedes": "https://cdn-icons-png.flaticon.com/512/15610/15610055.png",
  "Moths": "https://cdn-icons-png.flaticon.com/512/18149/18149752.png",
  "Praying Mantis": "https://cdn-icons-png.flaticon.com/512/11774/11774647.png",
  "Roaches": "https://cdn-icons-png.flaticon.com/512/47/47375.png",
  "Scorpions": "https://cdn-icons-png.flaticon.com/512/3268/3268611.png",
  "Spiders": "https://cdn-icons-png.flaticon.com/512/8689/8689753.png",
  "Tarantula": "https://cdn-icons-png.flaticon.com/512/4901/4901672.png",
  
  // Using cat as placeholder for mammals
  "Dogs": "https://cdn-icons-png.flaticon.com/512/15721/15721652.png",
  "Cows": "https://cdn-icons-png.flaticon.com/512/62/62470.png",
  "Goats": "https://cdn-icons-png.flaticon.com/512/4584/4584123.png",
  "Horses": "https://cdn-icons-png.flaticon.com/512/33/33348.png",
  "Llama": "https://cdn-icons-png.flaticon.com/512/8531/8531864.png",
  "Pigs": "https://cdn-icons-png.flaticon.com/512/47/47071.png",
  "Sheep": "https://cdn-icons-png.flaticon.com/512/66/66722.png",
  "Deer": "https://cdn-icons-png.flaticon.com/512/15707/15707633.png",
  "Exotic Mammals": "https://cdn-icons-png.flaticon.com/512/10890/10890561.png",
  "Fox": "https://cdn-icons-png.flaticon.com/512/10890/10890561.png",
  "Hedgehog": "https://cdn-icons-png.flaticon.com/512/8907/8907480.png",
  "Marsupials": "https://cdn-icons-png.flaticon.com/512/84/84452.png",
  "Monkeys": "https://cdn-icons-png.flaticon.com/512/10890/10890561.png",
  "Rodents": "https://cdn-icons-png.flaticon.com/512/7777/7777177.png",
  "Weasels": "https://cdn-icons-png.flaticon.com/512/10890/10890561.png",
  
  // Reptiles/Amphibians - using beetle for now
  "Axolotl": "https://cdn-icons-png.flaticon.com/512/3060/3060561.png",
  "Crocodilians": "https://cdn-icons-png.flaticon.com/512/8689/8689753.png",
  "Geckos": "https://cdn-icons-png.flaticon.com/512/47/47371.png",
  "Leopard Geckos": "https://cdn-icons-png.flaticon.com/512/14228/14228800.png",
  "Lizards": "https://cdn-icons-png.flaticon.com/512/16822/16822224.png",
  "Monitor Lizards": "https://cdn-icons-png.flaticon.com/512/17889/17889896.png",
  "Snakes": "https://cdn-icons-png.flaticon.com/512/8616/8616077.png",
  "Venomous Snakes": "https://cdn-icons-png.flaticon.com/512/8689/8689753.png",
  "Tortoises": "https://cdn-icons-png.flaticon.com/512/10654/10654014.png",
  "Turtles": "https://cdn-icons-png.flaticon.com/512/8531/8531935.png",
  "Frogs": "https://cdn-icons-png.flaticon.com/512/9516/9516112.png",
  "Toads": "https://cdn-icons-png.flaticon.com/512/10415/10415358.png",
  
  // Birds - using cat for now
  "Birds": "https://cdn-icons-png.flaticon.com/512/92/92009.png",
  "Birds of Prey": "https://cdn-icons-png.flaticon.com/512/10890/10890561.png",
  "Chickens": "https://cdn-icons-png.flaticon.com/512/4868/4868143.png",
  "Ducks": "https://cdn-icons-png.flaticon.com/512/17839/17839205.png",
  "Pigeons": "https://cdn-icons-png.flaticon.com/512/9829/9829084.png",
  
  // Marine - using beetle for now
  "Coral Reefs": "https://cdn-icons-png.flaticon.com/512/3823/3823092.png",
  "Crab": "https://cdn-icons-png.flaticon.com/512/166/166031.png",
  "Crinoids": "https://cdn-icons-png.flaticon.com/512/8824/8824327.png",
  "Eels": "https://cdn-icons-png.flaticon.com/512/12969/12969884.png",
  "Fish": "https://cdn-icons-png.flaticon.com/512/4659/4659358.png",
  "Hermit Crabs": "https://cdn-icons-png.flaticon.com/512/10904/10904240.png",
  "Octopus": "https://cdn-icons-png.flaticon.com/512/8689/8689753.png",
  "Sea Cucumbers": "https://cdn-icons-png.flaticon.com/512/7297/7297866.png",
  "Sea Horses": "https://cdn-icons-png.flaticon.com/512/13156/13156565.png",
  "Sea Mosses": "https://cdn-icons-png.flaticon.com/512/18730/18730083.png",
  "Sea Slugs": "https://cdn-icons-png.flaticon.com/512/15471/15471968.png",
  "Snails": "https://cdn-icons-png.flaticon.com/512/877/877225.png",
  
  // Plants - using cat for now
  "Fruit": "https://cdn-icons-png.flaticon.com/512/10890/10890561.png",
  "Herbal Spices": "https://cdn-icons-png.flaticon.com/512/4786/4786834.png",
  "Herbs": "https://cdn-icons-png.flaticon.com/512/53/53775.png",
  "Minerals": "https://cdn-icons-png.flaticon.com/512/11237/11237148.png",
  "Mushrooms": "https://cdn-icons-png.flaticon.com/512/10890/10890561.png",
  "Plants": "https://cdn-icons-png.flaticon.com/512/45/45777.png",
  "Vegetables": "https://cdn-icons-png.flaticon.com/512/10890/10890561.png",
};

// Default icon
const defaultIcon = "https://cdn-icons-png.flaticon.com/512/8689/8689753.png";

// Function to get icon by category name
export const getIconByName = (name) => {
  return catIconsMap[name] || defaultIcon;
};

export default catIconsMap;
